import { t } from 'i18next';
import { FC, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

import { useConfig, useResponsiveFormFactor } from '#/hooks';
import { ButtonVariant, FormFactors, StorageKeys } from '#/service/constants';

import Button from '../Button/Button';
import { FullPageModal, Modal } from '../Modal';
import Terms from './Terms';

interface Props {
  isAppReady: boolean;
}

export const TermsModal: FC<Props> = ({ isAppReady }) => {
  const formFactor = useResponsiveFormFactor();
  const { terms } = useConfig();
  const [showTerms, setShowTerms] = useState(false);

  const shouldShowTerms = useCallback(() => {
    const currentTermsVersion = localStorage.getItem(StorageKeys.TERMS);

    return (
      isAppReady &&
      terms.body &&
      (!currentTermsVersion || currentTermsVersion !== terms.date)
    );
  }, [isAppReady, terms]);

  const acceptTerms = useCallback(() => {
    setShowTerms(false);
    localStorage.setItem(StorageKeys.TERMS, terms.date);
  }, [terms.date]);

  useEffect(() => {
    if (shouldShowTerms()) {
      setShowTerms(true);
    }
  }, [shouldShowTerms, acceptTerms]);

  const ModalContents = () => (
    <>
      <Terms formFactor={formFactor} termsBody={terms.body} />
      <Button onClick={acceptTerms} variant={ButtonVariant.Primary}>
        {t('button.accept')}
      </Button>
    </>
  );

  if (formFactor === FormFactors.DESKTOP) {
    return (
      <Modal isOpen={showTerms} showCloseButton={false}>
        <ModalContents />
      </Modal>
    );
  }

  if (showTerms) {
    return (
      <StyledModal>
        <div>
          <ModalContents />
        </div>
      </StyledModal>
    );
  }

  return null;
};

const StyledModal = styled(FullPageModal)`
  align-items: center;
`;
